import { ChakraProvider } from "@chakra-ui/react";
import { AlertProvider } from "./context/alertContext";
import { Routes, Route, Link } from "react-router-dom";
import Home from "./components/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Newsletter from "./components/Newsletter";
import PreFooter from "./components/PreFooter";
import MoneyTransfer from "./components/MoneyTransfer";
import AboutUs from "./components/AboutUs";
import Promotion from "./components/Promotion";
import Community from "./components/Community";
import Influencer from "./components/Influencer";
import Help from "./components/Help";
import AgentDashboard from "./components/AgentDashboard";
import AgentLogin from "./components/AgentLogin";
import PrivacyPolicy from "./components/PrivacyPolicy"; 
import TermsOfService from "./components/TermsOfService";
import CanadaTerms from "./components/CanadaTerms";
import { useState } from "react";
import Resources from "./components/Resources";
import Blog from "./components/Blog";
import TopCountries2026 from "./components/TopCountries2026";
import BestTransferApps2026 from "./components/BestTransferApps2026";
import TopStrongestCurrencies2026 from "./components/TopStrongestCurrencies2026";
import AvoidingCurrencyScams2025 from "./components/AvoidingCurrencyScams2025";
import CheapestDestinationsBySeason from "./components/CheapestDestinationsBySeason";
import UnderstandingExchangeRates from "./components/UnderstandingExchangeRates";
import ImmigrationRoutesCanada2026 from "./components/ImmigrationRoutesCanada2026";
import AvoidHiddenFeesSendingMoney from "./components/AvoidHiddenFeesSendingMoney";
import SafeOnlineMoneyTransfers from "./components/SafeOnlineMoneyTransfers";

function App() {
  const [agentAuthed, setAgentAuthed] = useState(false);
  const handleLogout = () => setAgentAuthed(false);
  return (
    <ChakraProvider>
      <AlertProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/money-transfer" element={<MoneyTransfer />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/promotions" element={<Promotion />} />
          <Route path="/community" element={<Community />} />
          <Route path="/influencer" element={<Influencer />} />
          <Route path="/help" element={<Help />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/agent" element={agentAuthed ? <AgentDashboard onLogout={handleLogout} /> : <AgentLogin onLogin={() => setAgentAuthed(true)} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/canada-terms" element={<CanadaTerms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/top-7-countries-2026" element={<TopCountries2026 />} />
          <Route path="/blog/best-transfer-apps-2026" element={<BestTransferApps2026 />} />
          <Route path="/blog/top-10-strongest-currencies-2026" element={<TopStrongestCurrencies2026 />} />
          <Route path="/blog/avoiding-currency-exchange-scams" element={<AvoidingCurrencyScams2025 />} />
          <Route path="/blog/cheapest-destinations-by-season" element={<CheapestDestinationsBySeason />} />
          <Route path="/blog/understanding-exchange-rates" element={<UnderstandingExchangeRates />} />
          <Route path="/blog/immigration-routes-canada-2026" element={<ImmigrationRoutesCanada2026 />} />
          <Route path="/blog/avoid-hidden-fees-sending-money" element={<AvoidHiddenFeesSendingMoney />} />
          <Route path="/blog/safe-online-money-transfers" element={<SafeOnlineMoneyTransfers />} />
        </Routes>
        <Newsletter />
        <PreFooter/>
        <Footer />
      </AlertProvider>
    </ChakraProvider>
  );
}

export default App;
